import { z } from 'zod';
export const REMINDER_KINDS = [
    'tcp_permit',
    'insurance',
    'dmv_pull_notice',
    'drug_program',
    'airport_permit',
    'vehicle_inspection',
    'registration',
    'custom',
];
/** Ready-made reminders every California TCP driver needs; the driver fills in the dates. */
export const REMINDER_PRESETS = [
    { kind: 'tcp_permit', label: 'TCP permit renewal', hint: 'Every 3 years. Apply to the CPUC at least 90 days before it expires or the authority lapses.', leadDays: [120, 90, 30, 7] },
    { kind: 'insurance', label: 'Liability insurance expiry', hint: 'The insurer tells the CPUC when a policy lapses and the permit is suspended at once.', leadDays: [60, 30, 7] },
    { kind: 'dmv_pull_notice', label: 'DMV Employer Pull Notice check', hint: 'Enrolment must stay current for the permit to renew.', leadDays: [30, 7] },
    { kind: 'drug_program', label: 'Drug and alcohol testing program', hint: 'Consortium enrolment or annual certificate.', leadDays: [30, 7] },
    { kind: 'airport_permit', label: 'Airport permit (LAX, SNA, SAN…)', hint: 'Each airport has its own annual permit and decal.', leadDays: [60, 30, 7] },
    { kind: 'vehicle_inspection', label: 'Vehicle safety inspection', hint: 'The 19-point BAR inspection, every 12 months or 50,000 miles.', leadDays: [30, 7] },
    { kind: 'registration', label: 'Vehicle registration', hint: 'DMV registration renewal.', leadDays: [30, 7] },
];
export const ReminderInputSchema = z.object({
    kind: z.enum(REMINDER_KINDS),
    label: z.string().trim().min(2).max(80),
    /** YYYY-MM-DD in the driver's time zone. */
    dueOn: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'date must be YYYY-MM-DD'),
    leadDays: z.array(z.number().int().min(0).max(365)).min(1).max(6).default([90, 30, 7]),
    notes: z.string().trim().max(300).nullable().optional(),
    active: z.boolean().optional(),
});
/** Whole days from today (in the driver's zone) until the due date; negative when overdue. */
export function daysUntil(dueOn, todayYmd) {
    const a = Date.UTC(Number(dueOn.slice(0, 4)), Number(dueOn.slice(5, 7)) - 1, Number(dueOn.slice(8, 10)));
    const b = Date.UTC(Number(todayYmd.slice(0, 4)), Number(todayYmd.slice(5, 7)) - 1, Number(todayYmd.slice(8, 10)));
    return Math.round((a - b) / 86_400_000);
}
/** Which lead (if any) to send now: the smallest lead that is due and not yet sent, plus one overdue notice. */
export function leadToSend(leadDays, sent, days) {
    if (days < 0)
        return sent.overdue ? null : 'overdue';
    const due = leadDays.filter((l) => days <= l && !sent[String(l)]).sort((a, b) => a - b);
    return due.length ? String(due[0]) : null;
}
//# sourceMappingURL=reminders.js.map